import './SearchResult.scss'
import { useTranslation } from 'react-i18next'
import { roundNumber } from '../utils/Utils'
import { useDispatch, useSelector } from 'react-redux'
import { selectStore, setClickedStore } from '../redux/reducers/popupDataSlice'

const SearchResult = (props) => {

    const { t } = useTranslation();
    const storeDispatcher = useDispatch();
    const physicalStores = useSelector(state => state.popupData.physicalStores);
    const inputLocation = useSelector(state => state.popupData.inputLocation);
    const selectedStore = useSelector(state => state.popupData.selectedStore);
    var frameFound = false;



    var frameAvariableStores = physicalStores.filter((store, index) => store.x_storeFound === "true");
    if (frameAvariableStores.length !== 0){
        frameFound = true
        var storesList = frameAvariableStores.map((store, index) =>
        <div key={index}>
            <div className='container-fluid' onClick={() => clickedStore(store)}>
                <div className='row store-record'>
                    <div className='store-radio-input col-1'>
                        <input className='radio-input'
                            name='selected-store'
                            type='radio'
                            checked={selectedStore.uniqueID === store.uniqueID}
                            value={store}
                            onChange={() => storeDispatcher(selectStore(store))}
                        ></input>
                        <label></label>
                    </div>
                    <div className='col-7 store-name'>
                        {store.Description[0].displayStoreName.toLowerCase()}
                    </div>
                    <div className='col-4 store-miles align-right'>
                        {roundNumber(store.distance)}mi
    
                    </div>
                </div>
            </div>
        </div>
    );
    }else{
        frameFound = false
        var  storesList = physicalStores.map((store, index) =>
        <div key={index}>
            <div className='container-fluid' onClick={() => clickedStore(store)}>
                <div className='row store-record'>
                    <div className='store-radio-input col-1'>
                        <input className='radio-input'
                            name='selected-store'
                            type='radio'
                            checked={selectedStore.uniqueID === store.uniqueID}
                            value={store}
                            onChange={() => storeDispatcher(selectStore(store))}
                        ></input>
                        <label></label>
                    </div>
                    <div className='col-7 store-name'>
                        {store.Description[0].displayStoreName.toLowerCase()}
                    </div>
                    <div className='col-4 store-miles align-right'>
                        {roundNumber(store.distance)}mi

                    </div>
                </div>
            </div>
        </div>
    );
    }

    const clickedStore = (store) => {
        storeDispatcher(setClickedStore(true));
        storeDispatcher(selectStore(store));
    };

    return (
        <div className='container-fluid  container-record'>
            <div className='row search-info'>
                <div className='col-6'>
                    <span className="search-location">{inputLocation}</span>
                </div>
                <div className='col-6 align-right edit-containers' data-element-id='X_Pdp_FindStoreOverlay_ChangeLocation' onClick={props.onChangeLocation}><svg className="edit-icon"><use xlinkHref='#edit' /></svg><button className='change-location-btn'>{t('change-location')}</button></div>
            </div>
            {frameFound === false ?
                (
                    <div className='row search-info-description-container'>
                        <div className='col-12'>
                            <span className="search-info-no-store" dangerouslySetInnerHTML={{__html: t('found-no-stores')}}></span>
                            <br></br>
                            <span className="search-info-avaiable-store" dangerouslySetInnerHTML={{__html: t('stores-avaiable')}}></span>
                        </div>
                    </div>
                ) : (
                    <div className='col-12'>
                        <span className="search-info-description" dangerouslySetInnerHTML={{__html: t('found-stores')}}></span>
                    </div>
                )}
            <div className='container-fluid store-list-container'>
                <div className='stores-list'>
                    {storesList}
                </div>
            </div>
        </div>
    )

}

export default SearchResult
